var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav"},_vm._l((_vm.tabs),function(tab,index){return _c('router-link',{key:index,class:_vm.$route.name === tab.name && 'active',attrs:{"to":{ name: tab.name }}},[_vm._v("\n    "+_vm._s(tab.label)+"\n  ")])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6426cf72","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CategoryNav.vue
// module id = null
// module chunks = 